import { useEffect, useState } from "react";

const navLinks = [
  { label: "核心功能", href: "#features" },
  { label: "同城交友圈", href: "#cities" },
  { label: "单身群", href: "#groups" },
  { label: "聊天室", href: "#chatrooms" },
  { label: "缘分匹配", href: "#matching" },
  { label: "会员故事", href: "#stories" },
  { label: "常见问题", href: "#faq" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur border-b border-background-200"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-8">
        <div className="flex h-[72px] items-center justify-between gap-4">
          <a href="#home" className="flex items-center gap-2.5 cursor-pointer">
            <span className="flex h-10 w-10 items-center justify-center rounded-full bg-primary-500 text-background-50">
              <i className="ri-heart-3-fill text-xl" aria-hidden="true"></i>
            </span>
            <span className="flex flex-col leading-tight">
              <span className="font-heading text-xl text-foreground-950">爱情岛</span>
              <span className="text-[11px] text-foreground-600 tracking-wide">同城交友社区</span>
            </span>
          </a>

          <nav className="hidden lg:flex items-center gap-1">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="rounded-md px-3 py-2 text-sm text-foreground-700 transition-colors hover:bg-background-200/70 hover:text-primary-700 cursor-pointer whitespace-nowrap"
              >
                {link.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <a
              href="#join"
              className="hidden md:inline-flex items-center gap-1.5 rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-door-open-line" aria-hidden="true"></i>
              加入爱情岛
            </a>
            <button
              type="button"
              onClick={() => setOpen((v) => !v)}
              aria-label="打开导航菜单"
              aria-expanded={open}
              className="flex h-10 w-10 items-center justify-center rounded-md border border-background-300 text-foreground-800 transition-colors hover:bg-background-200/70 cursor-pointer lg:hidden"
            >
              <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"} aria-hidden="true"></i>
            </button>
          </div>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t border-background-200 bg-background-50/98 backdrop-blur px-4 py-3">
          <nav className="grid grid-cols-2 gap-1">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                className="rounded-md px-3 py-2.5 text-sm text-foreground-700 transition-colors hover:bg-background-200/70 hover:text-primary-700 cursor-pointer"
              >
                {link.label}
              </a>
            ))}
          </nav>
          <a
            href="#join"
            onClick={() => setOpen(false)}
            className="mt-2 flex items-center justify-center gap-1.5 rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50 cursor-pointer"
          >
            <i className="ri-door-open-line" aria-hidden="true"></i>
            加入爱情岛
          </a>
        </div>
      )}
    </header>
  );
}